import TooltipText from "../../components/common/TooltipText/TooltipText";

import {v4 as uuidv4} from "uuid";
import moment from "moment";

class TableYearHelper {
    static getCredentials(data, parentStyle) {
        const output = [];
        const style = {
            struct: "__department",
            name: "__worker",
            totalDays: "__vacation-days",
        };
        data.forEach((e) => {
            const temp = [];
            for (const key in e) {
                if (key === "struct" || key === "name" || key === "totalDays") {
                    temp.push(
                        <td
                            key={uuidv4()}
                            className={`${parentStyle}__body${style[key]}`}>
                            <div><div>{e[key]}</div></div>
                        </td>
                    );
                }
            }
            output.push(temp);
        });
        return output;
    }

    static getMonthsGantRow(data, parentStyle, setTooltip) {
        const output = [];
        data.forEach((element) => {
            // check if this employee has leaves
            // temp is row of months
            const temp = new Array(12).fill(null);

            if (element.planned && element.planned.length) {
                const row = temp.map((month, monthIndex) => {
                    // Собираем все отпуска для этого месяца
                    const vacationsInMonth = element.planned.filter(plannedVacation => {
                        const plannedVacationFrom = moment(plannedVacation.from).month();
                        const plannedVacationTo = moment(plannedVacation.to).month();

                        // Проверяем, попадает ли месяц в диапазон отпуска
                        if (plannedVacationTo - plannedVacationFrom >= 0) {
                            const period = plannedVacationTo - plannedVacationFrom;
                            for (let i = 0; i <= period; i += 1) {
                                if (plannedVacationFrom + i === monthIndex) {
                                    return true;
                                }
                            }
                        }

                        return plannedVacationFrom === monthIndex || plannedVacationTo === monthIndex;
                    });

                    // Если есть отпуска в этом месяце, создаем ячейку с ними
                    if (vacationsInMonth.length > 0) {
                        return this.filledCell(parentStyle, monthIndex, setTooltip, vacationsInMonth);
                    } else {
                        return this.emptyCell(parentStyle);
                    }
                });
                output.push(row);
            } else {
                output.push(temp.map(() => {
                    return this.emptyCell(parentStyle);
                }));
            }
        });
        return output;
    }

    static filledCell(parentStyle, monthIndex, setTooltip, plannedVacations) {
        let cellClass = "month-past";
        let year = null;

        // Определяем класс на основе последнего отпуска
        const lastVacation = plannedVacations[plannedVacations.length - 1];
        if (lastVacation && lastVacation.to) {
            year = moment(lastVacation.to, "YYYY-MM-DD").toDate().getFullYear();
            if (year >= moment().year() && moment().month() > monthIndex) cellClass = "month-regular";
        }

        const cellId = uuidv4();

        return <td key={`filled${cellId}`}
                   className={`${parentStyle}__body__month`}>
            <div
                name={"filled"}
                id={cellId}
                className={cellClass}
                onMouseLeave={() => {
                    setTimeout(() => setTooltip([]), 1); // Всегда передаем массив
                }}
                onMouseEnter={(e) => {
                    const elem = document.getElementById(e.target.id);
                    if (elem) {
                        const top = Number(elem.getBoundingClientRect().y);
                        const left = Number(elem.getBoundingClientRect().x);

                        // Создаем тултипы для всех отпусков в этом месяце
                        const tooltips = plannedVacations.map((vacation, index) =>
                            this.tooltipComponent(vacation, Math.ceil(top) + (index * 60), Math.ceil(left))
                        );

                        setTooltip(tooltips);
                    }
                }}
            >
            </div>
        </td>;
    }

    static emptyCell(parentStyle) {
        return <td
            key={uuidv4()}
            className={`${parentStyle}__body__month`}>
            <div></div>
        </td>;
    }

    static tooltipComponent(plannedMonth, top, left) {
        console.log("plannedMonth", plannedMonth);
        const data = {
            from: moment(plannedMonth.from).format("DD.MM"),
            to: moment(plannedMonth.to).format("DD.MM"),
            days: plannedMonth.days,
        };
        return (
            <div
                key={uuidv4()}
                className={"month-regular__pop-up"}
                style={
                    {
                        top: top,
                        left: left,
                        display: "block",
                    }
                }>
                <ul key={uuidv4()}
                    className={"month-regular__pop-up__list"}>
                    <TooltipText data={data} parentStyle={"month-regular"}/>
                </ul>
            </div>
        );
    }
}

export default TableYearHelper;
